import { render } from "./Practical.vue?vue&type=template&id=29553cad&scoped=true&ts=true"
import script from "./Practical.vue?vue&type=script&lang=ts"
export * from "./Practical.vue?vue&type=script&lang=ts"

import "./Practical.vue?vue&type=style&index=0&id=29553cad&lang=stylus&scoped=true"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29553cad"]])

export default __exports__